import React from 'react';
import {
  FDStack, FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import TaxStrategyMetaOverride
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyMetaOverrideSet';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import TaxStrategyItemLayout
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyItemLayout';

const TaxStrategyGroup = ({ groupResource, itemStatusCollection, onSubmit }) => {
  return (
    <FDStack direction={'column'} spacing={2}>
      <FDTitleText value={groupResource.attr('name')} size={'lg'} color={'textSecondary'} />
      <FDStack direction={'column'} spacing={2}>
        { groupResource.attr('items').resources().list().map((item) => (
          <MetaResourceRenderer
            key={item.id()}
            resource={item}
            metaOverrideSet={TaxStrategyMetaOverride}
            layout={TaxStrategyItemLayout}
            LayoutProps={{
              itemStatusCollection,
              onSubmit,
            }}
          />
        ))}
      </FDStack>
    </FDStack>
  );
};

TaxStrategyGroup.defaultProps = {
};

TaxStrategyGroup.propTypes = {
  groupResource: PropTypes.instanceOf(fr.Resource).isRequired,
  itemStatusCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default TaxStrategyGroup;
